import { inject, Injectable } from '@angular/core';
import { IVehicle } from '@okcargo-apps/shared-domain';
import {
  FindVehicleAsCarrierQuery,
  FindVehicleAsCarrierQueryHandler,
  OrderType,
  SearchVehiclesAsCarrierQuery,
  SearchVehiclesAsCarrierQueryHandler,
  VehicleFieldNames,
  VehicleForCarrierResponse,
} from '@okcargo/query-processor';
import { SearchOptionsInput, transformToSearchOptions } from '../query-repository/query.mapper';
import { FindOptions } from '../query-repository/query.model';
import { BaseQueryRepository } from '../query-repository/query.repository';
import { transformToIVehicle, transformToIVehicleList } from './vehicle.mapper';

@Injectable({
  providedIn: 'root',
})
export class VehicleQueryService {
  private readonly searchVehiclesAsCarrierQueryHandler: SearchVehiclesAsCarrierQueryHandler;
  private readonly findVehicleAsCarrierQueryHandler: FindVehicleAsCarrierQueryHandler;

  constructor() {
    const queryRepository = inject(BaseQueryRepository);

    this.searchVehiclesAsCarrierQueryHandler = new SearchVehiclesAsCarrierQueryHandler(queryRepository);
    this.findVehicleAsCarrierQueryHandler = new FindVehicleAsCarrierQueryHandler(queryRepository);
  }

  public async searchVehicles(options: SearchOptionsInput = {}): Promise<IVehicle[]> {
    const searchOptions: SearchOptionsInput = {
      order: [{ field: VehicleFieldNames.PLATE_NUMBER, type: OrderType.ASC }],
      ...options,
    };

    const response: VehicleForCarrierResponse[] = await this.searchVehiclesAsCarrierQueryHandler.handle(
      transformToSearchOptions(searchOptions) as unknown as SearchVehiclesAsCarrierQuery,
    );

    return transformToIVehicleList(response);
  }

  public async findVehicle(options: FindOptions): Promise<IVehicle | null> {
    const response: VehicleForCarrierResponse = await this.findVehicleAsCarrierQueryHandler.handle({
      id: options.id,
    } as FindVehicleAsCarrierQuery);

    return transformToIVehicle(response);
  }
}
